import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import './assets/css/style.css';
import "./assets/css/cmslandingpage.css";
import "./assets/css/master.css"
import { store } from "./_helpers/store";
import { Provider } from 'react-redux';
import Login from './components/admin/Login';
import App from './App';
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);


// 👇️ wrap App in Router
root.render(
  <Provider store={store}>
    <Router>
      <Routes>
        <Route index path='/' element={<Login />} />
        <Route exact path='/*' element={<App />} />
        <Route index path='/Logout' element={<Login />} />
      </Routes>
    </Router>
  </Provider>
);
